import { useMemo } from 'react'

import { StorableType, BaseValue } from '../validation'
import { useLocalStorageState, UseStorageStateOptions } from './useLocalStorageState'

type ReducedOptions<TType extends StorableType, TValue extends BaseValue<TType>> = Omit<
  UseStorageStateOptions<TType, TValue>,
  'type'
>

export function createLocalStorageHook<TType extends StorableType, TValue extends BaseValue<TType>>(
  key: string,
  options: UseStorageStateOptions<TType, TValue>,
) {
  return function useExtendedStorageState(externalOptions?: ReducedOptions<TType, TValue>) {
    const storageOptions = useMemo(() => {
      return {
        ...options,
        ...externalOptions,

        type: options.type,
      }
    }, [externalOptions])

    return useLocalStorageState(key, storageOptions)
  }
}
